import { render } from "./CommentInputGroup.vue?vue&type=template&id=d89bae90&scoped=true"
import script from "./CommentInputGroup.vue?vue&type=script&lang=js"
export * from "./CommentInputGroup.vue?vue&type=script&lang=js"

import "./CommentInputGroup.vue?vue&type=style&index=0&id=d89bae90&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d89bae90"]])

export default __exports__